import { AdminUser } from "@equipped/core/backend/client";
import { normalizeQuery } from "@equipped/core/content/search";

/**
 * Copied verbatim from `apps/admin-web/src/lib/userSearch.ts` (mirrors
 * `apps/admin/ui/userSearch.ts`) — same fold (`normalizeQuery`, case/accent-insensitive) over
 * email/firstName/lastName, so the People search box behaves identically on all three admins.
 */
export function userMatchesQuery(u: AdminUser, q: string): boolean {
  const n = normalizeQuery(q);
  if (!n) return true;
  const haystack = [u.email, u.firstName, u.lastName].filter(Boolean).join(" ");
  return normalizeQuery(haystack).includes(n);
}
